module.exports = __webpack_public_path__ + "static/media/em-108.15bcd0d2.png";